export const PAGE_ROUTE_META = {
  login: {
    featureName: "登录",
    componentName: "LoginPage",
    filePath: "src/pages/LoginPage/index.jsx",
  },
  main: {
    featureName: "医疗智能体首页",
    componentName: "App",
    filePath: "src/App.js",
  },
  agent: {
    featureName: "智能体广场",
    componentName: "AgentPlaza",
    filePath: "src/pages/AgentPlaza/index.jsx",
  },
  doctor_xu: {
    featureName: "AI医生对话",
    componentName: "AgentPage",
    filePath: "src/pages/AgentPage/index.jsx",
  },
  about: {
    featureName: "关于我们",
    componentName: "AboutPage",
    filePath: "src/pages/about/About.jsx",
  },
  scale: {
    featureName: "量表测评",
    componentName: "ScalePage",
    filePath: "src/pages/ScalePage/index.jsx",
  },
  meal_plan: {
    featureName: "配餐",
    componentName: "MealPlan",
    filePath: "src/pages/MealPlan/index.jsx",
  },
  basic_info: {
    featureName: "基础信息",
    componentName: "BasicInfo",
    filePath: "src/pages/BasicInfo/index.jsx",
  },
  food_query: {
    featureName: "食物查询",
    componentName: "FoodSearch",
    filePath: "src/pages/FoodSearch/index.jsx",
  },
  nutritionist: {
    featureName: "智能营养师",
    componentName: "NutritionistPage",
    filePath: "src/pages/NutritionistPage/index.jsx",
  },
  nutrition_assessment: {
    featureName: "营养评估",
    componentName: "NutritionAssessment",
    filePath: "src/pages/NutritionAssessment/index.jsx",
  },
  vip_renew: {
    featureName: "VIP续费",
    componentName: "VipRenewPage",
    filePath: "src/pages/VipRenewPage/index.jsx",
  },
  nutrition_manage: {
    featureName: "营养管理",
    componentName: "NutritionManage",
    filePath: "src/pages/NutritionManage/index.jsx",
  },
  sport_nutrition: {
    featureName: "运动营养",
    componentName: "SportNutrition",
    filePath: "src/pages/SportNutrition/index.jsx",
  },
  growth_development: {
    featureName: "生长发育",
    componentName: "GrowthDevelopment",
    filePath: "src/pages/GrowthDevelopment/index.jsx",
  },
  recipe_customization: {
    featureName: "食谱定制",
    componentName: "RecipeCustomization",
    filePath: "src/pages/RecipeCustomization/index.jsx",
  },
  ketogenic_diet: {
    featureName: "生酮饮食",
    componentName: "KetogenicDiet",
    filePath: "src/pages/KetogenicDiet/index.jsx",
  },
  user: {
    featureName: "我的主页",
    componentName: "UserPage",
    filePath: "src/pages/UserPage/index.jsx",
  },
};

export const getCurrentPageRouteMeta = ({ currentPage, isAuthorized }) => {
  if (!isAuthorized) return { routeKey: "login", ...PAGE_ROUTE_META.login };

  return {
    routeKey: currentPage,
    ...(PAGE_ROUTE_META[currentPage] || {
      featureName: "未知功能",
      componentName: "Unknown",
      filePath: "未配置",
    }),
  };
};
